import {
  styled,
  Typography as MuiTypography,
  Grid as MuiGrid,
} from "@mui/material";

const PREFIX = "DialogStyle";

export const classes = {
  warning: `${PREFIX}-warning`,
  button: `${PREFIX}-button`,
};

export const Typography = styled(MuiTypography)(() => ({
  [`&.${classes.warning}`]: {
    fontSize: 12,
    mt: 1,
  },
}));

export const Grid = styled(MuiGrid)(() => ({
  [`&.${classes.button}`]: {
    marginTop: "15px",
    justifyContent: "center",
  },
}));
